// items in Region selection menu
const regions = [
    {'label': '- Climate Regions -', 'states': -1, 'value': 0},
    {'label': 'CONUS', 'states': 'WA-MN-FL-ME', 'value': 1},
    {'label': 'Northeast', 'states': 'ME-PA-MD', 'value': 2},
    {'label': 'Southeast', 'states': 'VA-FL-AL-NC', 'value': 3},
    {'label': 'Upper Midwest', 'states': 'MN-IA-MI', 'value': 4},
    {'label': 'Ohio Valley', 'states': 'IL-MO-TN-WV', 'value': 5},
    {'label': 'South', 'states': 'KS-TX-MS', 'value': 6},
    {'label': 'Northern Rockies & Plains', 'states': 'MT-NE', 'value': 7},
    {'label': 'Northwest', 'states': 'WA-ID', 'value': 8},
    {'label': 'West', 'states': 'CA-NV', 'value': 9},
    {'label': 'Southwest', 'states': 'UT-AZ-CO', 'value': 10},
    {'label': '- Regional Climate Centers -', 'states': -2, 'value': 11},
    {'label': 'Northeast', 'states': 'ME-WV', 'value': 12},
    {'label': 'Southeast', 'states': 'VA-FL-AL-NC', 'value': 13},
    {'label': 'Midwestern', 'states': 'MN-IA-MO-OH', 'value': 14},
    {'label': 'Southern', 'states': 'TX-OK-TN', 'value': 15},
    {'label': 'High Plains', 'states': 'ND-WY-KS', 'value': 16},
    {'label': 'Western', 'states': 'CA-MT-NM', 'value': 17},
    {'label': '- NWS Regions -', 'states': -3, 'value': 18},
    {'label': 'Eastern', 'states': 'ME-OH-SC', 'value': 19},
    {'label': 'Southern', 'states': 'NM-OK-TX-FL', 'value': 20},
    {'label': 'Central', 'states': 'WY-MN-MI-KY-MO', 'value': 21},
    {'label': 'Western', 'states': 'WA-MT-CA', 'value': 22},
    {'label': '- NCA Regions -', 'states': -4, 'value': 23},
    {'label': 'Northeast', 'states': 'ME-WV', 'value': 24},
    {'label': 'Southeast', 'states': 'VA-FL-AR', 'value': 25},
    {'label': 'Midwest', 'states': 'MN-IA-MO-OH', 'value': 26},
    {'label': 'Great Plains', 'states': 'MT-TX', 'value': 27},
    {'label': 'Northwest', 'states': 'WA-ID', 'value': 28},
    {'label': 'Southwest', 'states': 'CA-WY-NM', 'value': 29},
];

// maximum bounding box bounds
const maxbbox = {
    west: -124.66667,
    south: 24.541699,
    east: -67.000000,
    north: 49.333366,
};

export { regions, maxbbox };